﻿window.cObjetSondageReponseMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetTableUpdateLib = function () { return ["sondage_reponse"] }

    this.mGetLibBase = function () { return "Réponse sondage"; }
    this.mGetAttributBase = function () { return "le" }
    this.mGetNewLib = function () { return "Nouvelle réponse sondage"; }
    this.mGetLib1 = function (option) {
        if (typeof option == 'undefined') option = {}
        if (typeof option.dataTemplate != 'undefined') {
            return mGetLib1(option.dataTemplate)
        } else {
            if (typeof objet.data == 'undefined') {
                if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack("") }
                else { return "" }
            } else {
                var txt = ""
                if (Me.objet.cle() == null) {
                    if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
                    else { return txt }
                } else {
                    Me.objet.bddRef.mAjaxCall({
                        command: "getlstdatavirtualgrid",
                        data: [{ id_table: Me.objet.mGetTable().id_table, id: Me.objet.cle() }],
                        async: (typeof option.callBack != 'undefined')
                    }, function (data) {
                        var dataTemplate = ((typeof data.lstdatatemplate == "undefined") ? null : data.lstdatatemplate[0])
                        txt = ((dataTemplate == null) ? "" : mGetLib1(dataTemplate))
                    })
                    return txt
                }
            }
        }

        function mGetLib1(dataTemplate) {
            var txt = ""
            if (dataTemplate.id_table_destinataire) {
                if (dataTemplate.nom_str && dataTemplate.nom_str.length > 0) txt += dataTemplate.nom_str
                if (dataTemplate.con_nom && dataTemplate.con_nom.length > 0) txt += (txt.length > 0 ? " " : "") + dataTemplate.con_nom
                if (dataTemplate.con_prenom && dataTemplate.con_prenom.length > 0) txt += (txt.length > 0 ? " " : "") + dataTemplate.con_prenom
                if (txt.length == 0) {
                    txt = "(Contact sans nom)"
                }
            } else {
                txt = "(Aucun contact)"
            }
            txt += " &bull; " + dataTemplate.nom_sondage
            if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
            else { return txt }
        }
        //var txt = ""
        //if (typeof objet.data != 'undefined') { txt = ((objet.data.nom) ? objet.data.nom : "(aucun nom pour le sondage)") }
        //else {
        //    txt = "Réponse sondage"
        //}
        //if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        //else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i style='position:relative' class='fas fa-clipboard-question' title='Réponse sondage'><i class='fas fa-reply dx-theme-accent-as-text-color' style='position:absolute;bottom:-2px;right:-2px;font-size:60%;'></i></i>");
    }


    this.mGetItemTemplateHeight = function (type) {
        return 55
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();

    }

    this.mGetNomFromTemplate = function (dataTemplate) {
        return "Nouvel réponse sondage"
    }
    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {

        if (dataTemplate.vue == "0") {
            contentElement.closest(".divtemplate").css("opacity", "1")
            contentElement.closest(".divtemplate").css("box-shadow", "0 0 5px 0 #ffffff")
            if (objet.bddRef.theme.contains(".light")) {
                contentElement.closest(".divtemplate").css("box-shadow", "0 0 5px 0 #000000")
            }
        } else {
            contentElement.closest(".divtemplate").css("opacity", "0.7")
        }

        var $Table = $("<table style='table-layout:fixed;width:100%;'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)

        var $TdNomSondage = $("<td style='width:100%;text-overflow:ellipsis;overflow:hidden;font-weight:bold;'></td>").appendTo($Tr)
        $TdNomSondage.text(dataTemplate.nom_sondage)


        var $TdSatisfation = $("<td style='width:50px;text-overflow:ellipsis;overflow:hidden;'><span style='font-weight:bold;'>" + (dataTemplate.taux_satisfaction == null ? "(aucun)" : dataTemplate.taux_satisfaction + "%") + "</span></td>").appendTo($Tr)
        $TdSatisfation.attr("title", (dataTemplate.taux_satisfaction == null ? "(aucun taux de satisfaction)" : "Vous avez un taux de satisfaction de <b>" + dataTemplate.taux_satisfaction + "%</b><br/> pour ce répondant."))

        var $TdFinalise = $("<td style='width:40px;font-size:140%;'></td>").appendTo($Tr)
        if (dataTemplate.finalise == "0") {
            var $icone = $("<i class='fas fa-circle-half-stroke' style='color:red;'></i>").appendTo($TdFinalise)
            $TdFinalise.attr("title", "Le répondant n'est pas allé au bout du sondage. Ces réponses sont incomplétes.")
        } else {
            var $icone = $("<i class='fas fa-circle' style='color:green;'></i>").appendTo($TdFinalise)
            $TdFinalise.attr("title", "Le répondant est allé au bout du sondage. Il a répondu à toutes les questions et a affiché la dernière pas du sondage.")
        }

        //var $TdVue = $("<td style='width:30px;font-size:140%;'></td>").appendTo($Tr)
        //if (dataTemplate.vue == "0") {
        //    $("<i class='fas fa-eye-slash state-hover' style='color:orange'></i>").appendTo($TdVue)
        //    $TdVue.attr("title", "Vous n'avez pas encore vu cette réponse au sondage.<br/>Cliquez pour le marquer comme vu.")
        //} else {
        //    $("<i class='fas fa-eye state-hover' style='color:green'></i>").appendTo($TdVue)
        //    $TdVue.attr("title", "Vous avez vu cette réponse au sondage.<br/>Cliquez pour le marquer comme non vu.")
        //}
        //$TdVue.on("click", function (e) {
        //    e.stopPropagation()
        //    var obj = objet.bddRef.getObjet("sondage_reponse",dataTemplate.id_sondage_reponse)
        //    obj.data.vue = (obj.data.vue == "0" ? "1" : "0")
        //    obj.mSaveChamp("vue")
        //})

        var $Table = $("<table style='table-layout:fixed;width:100%;'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)
        var $TdNom = $("<td style='width:100%;text-overflow:ellipsis;overflow:hidden;font-weight:bold;'></td>").appendTo($Tr)
        var txt = ""
        if (dataTemplate.id_table_destinataire) {
            if (dataTemplate.nom_str && dataTemplate.nom_str.length > 0) txt += dataTemplate.nom_str
            if (dataTemplate.con_nom && dataTemplate.con_nom.length > 0) txt += (txt.length > 0 ? " " : "") + dataTemplate.con_nom
            if (dataTemplate.con_prenom && dataTemplate.con_prenom.length > 0) txt += (txt.length > 0 ? " " : "") + dataTemplate.con_prenom
            if (txt.length == 0) {
                txt = "(Contact sans nom)"
                $TdNom.css("font-weight", "normal")
            }
        } else {
            txt = "(Aucun contact lié à cette réponse)"
            $TdNom.css("font-weight", "normal")
        }
        $TdNom.text(txt)

    }
    this.itemTemplateGrillePlus = function (contentElement, dataPlus, option) {
        $("<span style='' title='Répondu le " + dataPlus.dcr.toFrenchDateTime() + "'><i class='fas fa-reply dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dcr.toDateIlya(true) + "</span>").appendTo(contentElement)
    }

    this.isPopupFullScreen = false
    //this.mShowPopup = function (option) {
    //    if (typeof option == 'undefined') option = {}
    //    option.fullScreen = true
    //    page.mAddPopup(objet.data, option)
    //}
    this.contentTemplatePopup = function (contentElement, option) {
        contentElement.empty();
        var dxCtrl = $("<div style='height:100%;width:100%;'/>").appendTo(contentElement).dxCtrlContentSondageReponse({
            bddCtrl: objet.bddRef,
            dataSondageReponse: objet.data,
            optionPopup: option
        }).dxCtrlContentSondage("instance")
    }

    this.mGetWidthPopup = function () { return 700 }
    this.mGetFullScreenPopup = function () { return false }

    this.mGetPopupPositionWidthHeight = function () {
        return {
            width: "calc(100% - 60px)",
            maxWidth: "calc(100% - 60px)",
            height: "calc(100% - 90px)",
            maxHeight: "calc(100% - 50px)",
            position: {
                my: "right top",
                at: "right top",
                of: "body",
                offset: { x: -30, y: 65 }
            }
        }
    }

}